import { Component, OnInit, Input } from '@angular/core';
import { BusinessDetailsService } from '@app/services/BusinessDetails/businessDetails.service';
import { ActivatedRoute } from '@angular/router';
import { BusinessExtraInfo } from '@app/model/business-extra-info';
import { environment } from '../../../../environments/environment.prod';

@Component({
  selector: 'app-extra-products',
  templateUrl: './extra-products.component.html',
  styleUrls: ['./extra-products.component.scss']
})
export class ExtraProductsComponent implements OnInit {
  userInfoId: any;
  extraItemInfo: any;
  data: any;

  constructor(
    private businessService: BusinessDetailsService,
    private route: ActivatedRoute
  ) { }
  
  serverImgUrl = environment.IMG_URL;
  
  modal: any;
  modalTitle:any;
  modalImg : any;

  ngOnInit() {
    this.modal = document.getElementById("myModal");

    this.route.params.subscribe(params => {
      this.userInfoId = params['uid'];
    })
    if(this.userInfoId){
      this.fetchExtraProductList();
    } 
  }

  fetchExtraProductList() {
    this.businessService.getExtraProductInfoByUUId(this.userInfoId)
      .subscribe({
        next: (res:any) => {
          if (res.success !== 0) {
            this.extraItemInfo = res as BusinessExtraInfo; 
          } else {
            this.extraItemInfo = "Not added details"; 
          }
        },
        //error: (e) => console.error('Error loading business info details.', e)
      });
  }
  
  onClick(event:any, title:any){
    this.modal.style.display = "block";
    this.modal.classList.add('show');
    this.modalTitle = title;
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;
    this.modalImg = srcAttr.nodeValue;
  }
  
  closeModal(){
    this.modal.style.display = "none";
    this.modal.classList.remove('show');
  }
}
